import { Component } from '@angular/core';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent {
}



// WEBPACK FOOTER //
// ./Client/app/components/navmenu/navmenu.component.ts